module.exports = __webpack_public_path__ + "static/media/allotracRect.478c3256.png";